<template>
  <div class="hiring-manager">
    <p v-if="hiringManagers.length === 1">
      {{ hiringManagers[0] }}
    </p>
    <p v-else-if="hiringManagers.length > 1">
      {{ hiringManagers[0] }}
      <em>{{ `+ ${hiringManagers.length - 1} More` }}</em>
    </p>
    <p v-else />
  </div>
</template>

<script setup>
defineProps({
  hiringManagers: {
    type: Array,
    default: () => [],
  },
});
</script>

<style lang="less" scoped>
.hiring-manager {
  max-width: 100%;

  p {
    font-size: 13px !important;
    font-weight: 500 !important;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
}
</style>
